module.exports = __webpack_public_path__ + "static/logo-icon-940a5f760d38dc9a4688a6e8e834cda5.png";